(function () {
  var SECTION_SELECTOR = '.oddit-section-ugc-carousel';
  var sectionState = new Map();

  function initVideoSlide(slide) {
    var video = slide.querySelector('[data-ugc-video]');
    if (!video) return;

    var isFullPlay = false;
    var isHovering = false;

    // Hovering plays the video with sound (QA: ALY-58). Browsers can block
    // unmuted autoplay that isn't triggered by a click — in that case we retry
    // muted so the video still plays visually rather than failing silently.
    function playWithSound() {
      video.muted = false;
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () {
          if (!isHovering || isFullPlay) return;
          video.muted = true;
          var retry = video.play();
          if (retry && typeof retry.catch === 'function') retry.catch(function () {});
        });
      }
    }

    function resetToPoster() {
      video.pause();
      try { video.currentTime = 0; } catch (e) {}
      video.removeAttribute('controls');
      video.muted = true;
      isFullPlay = false;
    }

    slide.addEventListener('mouseenter', function () {
      isHovering = true;
      if (isFullPlay) return;
      video.removeAttribute('controls');
      try { video.currentTime = 0; } catch (e) {}
      playWithSound();
    });

    slide.addEventListener('mouseleave', function () {
      isHovering = false;
      if (isFullPlay) return;
      resetToPoster();
    });

    slide.addEventListener('click', function () {
      // Click pins playback and shows native controls, with guaranteed sound
      // (a click is always a valid gesture for unmuted playback).
      if (isFullPlay) return;
      isFullPlay = true;
      try { video.currentTime = 0; } catch (e) {}
      video.muted = false;
      video.setAttribute('controls', '');
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    });

    video.addEventListener('ended', resetToPoster);
  }

  function initSection(section) {
    var track = section.querySelector('[data-ugc-track]');
    if (!track) return;

    var prevButtons = section.querySelectorAll('[data-ugc-prev]');
    var nextButtons = section.querySelectorAll('[data-ugc-next]');
    var slides = track.querySelectorAll('.oddit-section-ugc-carousel__slide');
    if (!slides.length) return;

    section.querySelectorAll('[data-ugc-video-slide]').forEach(initVideoSlide);

    function getSlideWidth() {
      var first = slides[0];
      if (!first) return 0;
      var rect = first.getBoundingClientRect();
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return rect.width + gap;
    }

    function getVisibleCount() {
      var trackWidth = track.clientWidth;
      var styles = window.getComputedStyle(track);
      var paddingLeft = parseFloat(styles.paddingLeft) || 0;
      var paddingRight = parseFloat(styles.paddingRight) || 0;
      var contentWidth = trackWidth - paddingLeft - paddingRight;
      var slideWidth = getSlideWidth();
      if (slideWidth <= 0) return 1;
      return Math.max(1, Math.floor(contentWidth / slideWidth));
    }

    function updateButtonStates() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft >= maxScroll - 1;

      for (var i = 0; i < prevButtons.length; i++) {
        prevButtons[i].disabled = atStart;
      }
      for (var j = 0; j < nextButtons.length; j++) {
        nextButtons[j].disabled = atEnd;
      }
    }

    function scrollByOne(direction) {
      var slideWidth = getSlideWidth();
      var visible = getVisibleCount();
      var step = slideWidth * Math.max(1, visible - 1);
      // For single-visible mobile layout, move by one slide.
      if (visible <= 1) step = slideWidth;

      track.scrollBy({
        left: direction * step,
        behavior: 'smooth'
      });
    }

    function handlePrev() {
      scrollByOne(-1);
    }

    function handleNext() {
      scrollByOne(1);
    }

    for (var i = 0; i < prevButtons.length; i++) {
      prevButtons[i].addEventListener('click', handlePrev);
    }
    for (var j = 0; j < nextButtons.length; j++) {
      nextButtons[j].addEventListener('click', handleNext);
    }

    var scrollRafId = null;
    function onScroll() {
      if (scrollRafId) return;
      scrollRafId = requestAnimationFrame(function () {
        updateButtonStates();
        scrollRafId = null;
      });
    }

    track.addEventListener('scroll', onScroll, { passive: true });

    var resizeObserver = null;
    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(function () {
        updateButtonStates();
      });
      resizeObserver.observe(track);
    }

    // Initial state
    updateButtonStates();

    sectionState.set(section, {
      track: track,
      onScroll: onScroll,
      scrollRafId: scrollRafId,
      resizeObserver: resizeObserver,
      handlePrev: handlePrev,
      handleNext: handleNext,
      prevButtons: prevButtons,
      nextButtons: nextButtons
    });
  }

  function destroySection(section) {
    var state = sectionState.get(section);
    if (!state) return;

    if (state.scrollRafId) cancelAnimationFrame(state.scrollRafId);
    state.track.removeEventListener('scroll', state.onScroll);

    for (var i = 0; i < state.prevButtons.length; i++) {
      state.prevButtons[i].removeEventListener('click', state.handlePrev);
    }
    for (var j = 0; j < state.nextButtons.length; j++) {
      state.nextButtons[j].removeEventListener('click', state.handleNext);
    }

    if (state.resizeObserver) {
      state.resizeObserver.disconnect();
    }

    sectionState.delete(section);
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();